import React from 'react'

const FORMATS = [
  { value: 'xlsx', name: 'XLSX', desc: 'One sheet per indicator' },
  { value: 'csv', name: 'CSV', desc: 'Single long-format file' },
  { value: 'json', name: 'JSON', desc: 'Array of records' },
]

function DataCenterSummary({
  countriesCount,
  indicatorsCount,
  seriesCount,
  frequency,
  yearFrom,
  yearTo,
  format,
  onFormatChange,
  onDownload,
  downloading,
  disabled,
  progress,
  onShare,
}) {
  const progressPct = progress && progress.total > 0 ? Math.round((progress.completed / progress.total) * 100) : 0

  return (
    <div className="dc-panel" id="dcDownload">
      <div className="dc-summary-head">
        <span>Dataset summary</span>
        <h3>Ready to build</h3>
      </div>

      <div className="dc-metrics">
        <div className="dc-metric"><strong>{indicatorsCount}</strong><span>Indicators</span></div>
        <div className="dc-metric"><strong>{countriesCount}</strong><span>Countries</span></div>
        <div className="dc-metric"><strong>{seriesCount}</strong><span>Download jobs</span></div>
        <div className="dc-metric"><strong>{frequency}</strong><span>Frequency</span></div>
      </div>

      <dl className="dc-rows">
        <div className="dc-row"><dt>Countries</dt><dd>{countriesCount > 0 ? `${countriesCount} selected` : '—'}</dd></div>
        <div className="dc-row"><dt>Indicators</dt><dd>{indicatorsCount > 0 ? `${indicatorsCount} selected` : '—'}</dd></div>
        <div className="dc-row"><dt>Frequency</dt><dd>{frequency}</dd></div>
        <div className="dc-row"><dt>Date range</dt><dd>{yearFrom} – {yearTo}</dd></div>
      </dl>

      <div className="dc-panel-body" style={{ borderTop: '1px solid var(--landing-border)' }}>
        <div className="dc-label"><span>Format</span></div>
        <div className="dc-formats">
          {FORMATS.map((f) => (
            <button
              type="button"
              key={f.value}
              className={`dc-format${format === f.value ? ' is-on' : ''}`}
              onClick={() => onFormatChange(f.value)}
            >
              <div className="dc-format-name">{f.name}</div>
              <div className="dc-format-desc">{f.desc}</div>
            </button>
          ))}
        </div>

        <button className="dc-download" onClick={onDownload} disabled={disabled || downloading}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12" /><path d="m7 11 5 5 5-5" /><path d="M4 20h16" /></svg>
          <span>{downloading ? 'Building dataset…' : 'Download'}</span>
        </button>

        <div className="dc-secondary-actions">
          <button type="button" className="dc-ghost" onClick={onShare}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a4 4 0 0 0 5.7.4l3-3A4 4 0 0 0 13 4.7l-1.2 1.2" /><path d="M14 11a4 4 0 0 0-5.7-.4l-3 3A4 4 0 0 0 11 19.3l1.2-1.2" /></svg>
            Share config
          </button>
        </div>

        {progress && progress.total > 0 && (
          <div className="dc-progress">
            <div className="dc-progress-bar">
              <div className="dc-progress-fill" style={{ width: `${progressPct}%` }} />
            </div>
            <div className="dc-progress-label">
              <span>{progress.completed} / {progress.total} indicators fetched</span>
              <span>{progressPct}%</span>
            </div>
            <div className="dc-progress-list">
              {progress.items.map((item) => (
                <div className="dc-progress-item" key={item.name}>
                  <span>{item.name}</span>
                  <span className={item.status === 'done' ? 'is-ok' : item.status === 'error' ? 'is-fail' : 'is-pending'}>
                    {item.status === 'done' ? `✓ ${item.rows} rows` : item.status === 'error' ? '✗ failed' : '…'}
                  </span>
                </div>
              ))}
            </div>
            <p className="dc-inline-note">
              Indicators download in parallel, so this list may finish out of order. The final file is always
              ordered to match your selection, regardless of which requests complete first.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default DataCenterSummary
